import eventBus from '~/events/eventBus'
import eventDefinitions from '~/events/eventDefinitions'

eventBus.$on(eventDefinitions.CART.ITEM.ADD, ({ addedAmount, item }) => {
  //
})
